import type { FilterInSaleAndStopSellingProps, InSaleAndStopSellingItemsType } from "../../../type";

export const SALE_STATUS = (itemsName: FilterInSaleAndStopSellingProps["itemsName"]) => {
	return {
		IN_SALE: {
			SELECT_ALL_ID: "in-sale-all",
			SELECT_ALL_ITEM: {
				id: "in-sale-all",
				name: `販売中の${itemsName}全てを表示する`,
			} satisfies InSaleAndStopSellingItemsType[number],
			LABEL: `販売中の${itemsName}`,
		},
		STOP_SELLING: {
			SELECT_ALL_ID: "stop-selling-all",
			SELECT_ALL_ITEM: {
				id: "stop-selling-all",
				name: `非公開の${itemsName}全てを表示する`,
			} satisfies InSaleAndStopSellingItemsType[number],
			LABEL: `非公開の${itemsName}`,
		},
	} as const;
};
